import React, { FC } from 'react'
import { Route } from 'react-router-dom'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { Page } from '../components/Page'

const Loading = () => <Page>Loading...</Page>

const ProtectedRoute = ({ component, ...args }: { component: FC; path: string }) => (
  <Route
    component={withAuthenticationRequired(component, {
      onRedirecting: () => <Loading />,
    })}
    {...args}
  />
)

export default ProtectedRoute
